<template>
  <main>
    <section>
      <div class="container font-weight-light bg-white py-5" style="margin-top: 7.5rem;">
        <div class="row justify-content-center">
          <div class="col-12 mb-5 text-center">
            <h2 class="font-cursive">{{ title }}</h2>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-4 col-5 text-center" v-for="(item, index) in images" :key="index">
            <div class="row justify-content-center px-md-3 px-2 h-100">
              <div class="col-lg-6 col-md-8 col-11">
                <img :src="item.img" alt="" class="img-fluid mb-3">
              </div>
              <div class="col-12 border-medio-bottom border-icons mb-5 pb-3">
                <h5 class="text-lead mb-0">{{ item.title }}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="card bg-dark text-white vh-100 rounded-0">
        <img :src="require('@/assets/images/control_de_calidad.jpg')" class="card-img h-100">
        <div class="card-img-overlay">
          <div class="container h-100 text-justify font-weight-light">
            <div class="row align-items-center h-100 justify-content-center">
              <div class="col-md-8">
                <h2 class="mb-2">{{ control.title }}</h2>
                <p class="text-lead font-weight-light mb-3">{{ control.description }}</p>
                <p class="text-lead font-weight-light">{{ control.description2 }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="container py-5">
        <div class="d-flex mb-2">
          <h2 class="font-cursive border-super-bottom border-danger pb-2 pr-2">{{ responsible.title }}</h2>
        </div>
        <p class="text-lead mb-3">{{ responsible.description }}</p>
        <p class="text-lead font-weight-bold mb-3">{{ responsible.description2 }}</p>
      </div>
      <div class="container">
        <div class="d-flex mb-2">
          <h2 class="font-cursive border-super-bottom border-danger pb-2 pr-2">{{ equipment.title }}</h2>
        </div>
        <p class="text-lead mb-3">{{ equipment.description }}</p>
      </div>
      <div class="container pt-5 pb-3 border-medio-bottom border-danger mb-4">
        <div class="d-flex mb-2">
          <h2 class="font-cursive border-super-bottom border-danger pb-2 pr-2">{{ partner.title }}</h2>
        </div>
        <p class="text-lead mb-3">{{ partner.description }}</p>
        <p class="text-lead">{{ partner.description2 }}</p>
      </div>
    </section>
  </main>
</template>
<script>
import text_en from '../../text/en/experience'
import text_es from '../../text/es/experience'
export default {
  data(){
    return{
      images: window.lang == 'es' ? text_es.images : text_en.images,
      title: window.lang == 'es' ? text_es.title : text_en.title,
      control: window.lang == 'es' ? text_es.control : text_en.control,
      responsible: window.lang == 'es' ? text_es.responsibles : text_en.responsibles,
      equipment: window.lang == 'es' ? text_es.equipment : text_en.equipment,
      partner: window.lang == 'es' ? text_es.partner : text_en.partner
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/experience.vue